/**
 * Error raised after a questionnaire save mutation fails and compensation was
 * attempted. The original backend error is kept so the UI can preserve its
 * message while still warning about an incomplete cleanup when necessary.
 */
export class QuestionarioSaveError extends Error {
  override readonly name = 'QuestionarioSaveError';

  constructor(
    public readonly originalError: unknown,
    public readonly rollbackErrors: readonly unknown[],
    public readonly rollbackComplete: boolean,
  ) {
    super('Falha ao salvar o questionário.');
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
